module.exports = __webpack_public_path__ + "media/images/triangle--up-1fa0d182cb8944570f3cbf440e4bf8a0.png";